import LongTermDescription from './LongTermDescription';

export default LongTermDescription;
